import { Mode } from '@/types/environment'

/* Получить домейн первого уровня (ru/com/kg...) */
export const getCountryDomain = (hostname: string) => {
  const MODE = useRuntimeConfig().public.MODE || process.env.ENV

  let domain = hostname.split('.').slice(-1)[0]

  if (Mode.DEVELOPMENT === MODE) {
    domain = 'ru'
  }

  return domain
}
